import React, { useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  return <header className="bg-[#8A9A5B] shadow-sm sticky top-0 z-50" data-id="element-236" data-mp="2ikfpul52nxfn">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-237" data-mp="2nkakmzryx75z">
        <div className="flex justify-between items-center py-4" data-id="element-238" data-mp="2niha39e8i2sp">
          <div className="flex items-center" data-id="element-239" data-mp="2rl49bvd8ipzx">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/mhSQzqAkdBcNMQ8aCTM7Tt/Gray_Logo.png" alt="Meyer Bookkeeping & Tax Logo" className="h-12 w-auto" data-id="element-240" data-mp="2rkb6h5heckn2" />
          </div>
          {/* Desktop navigation */}
          <nav className="hidden md:flex space-x-8" data-id="element-241" data-mp="36aa3v614ns1h">
            <a href="#services" className="text-white hover:text-gray-200 text-sm font-medium" data-id="element-242" data-mp="3baob4luwmxyg">
              Services
            </a>
            <a href="#process" className="text-white hover:text-gray-200 text-sm font-medium" data-id="element-243" data-mp="2wkun6w6r9n7c">
              Process
            </a>
            <a href="#testimonials" className="text-white hover:text-gray-200 text-sm font-medium" data-id="element-244" data-mp="2rkghhksmmpch">
              Testimonials
            </a>
            <a href="#about" className="text-white hover:text-gray-200 text-sm font-medium" data-id="element-245" data-mp="2hp4xoo2d2rxv">
              About
            </a>
            <a href="#faq" className="text-white hover:text-gray-200 text-sm font-medium" data-id="element-246" data-mp="3abzhrjv9npat">
              FAQ
            </a>
            <a href="/contact" className="bg-[#3A4A46] text-white px-4 py-2 rounded hover:bg-opacity-80 transition-colors" data-id="element-247" data-mp="30mfwy8nztldb">
              Book a Call
            </a>
          </nav>
          {/* Mobile menu button */}
          <div className="md:hidden" data-id="element-248" data-mp="3t9k6mqy16nvf">
            <button onClick={toggleMenu} className="text-white hover:text-gray-200 focus:outline-none" data-id="element-249" data-mp="1rdl2kdrc1bxx">
              {isMenuOpen ? <XIcon className="h-6 w-6" data-id="element-250" data-mp="1weqwgewqb591" /> : <MenuIcon className="h-6 w-6" data-id="element-251" data-mp="1hmqhhcptoie2" />}
            </button>
          </div>
        </div>
      </div>
      {/* Mobile menu */}
      {isMenuOpen && <div className="md:hidden bg-[#9BAB6C] border-t border-[#79894A]" data-id="element-252" data-mp="18mk5jv9rvqh0">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3" data-id="element-253" data-mp="18pg2phdsqb4e">
            <a href="#services" className="block px-3 py-2 text-base font-medium text-white hover:bg-[#79894A]" onClick={() => setIsMenuOpen(false)} data-id="element-254" data-mp="1cq8dwg68aq3b">
              Services
            </a>
            <a href="#process" className="block px-3 py-2 text-base font-medium text-white hover:bg-[#79894A]" onClick={() => setIsMenuOpen(false)} data-id="element-255" data-mp="2t2x6jhcf6pup">
              Process
            </a>
            <a href="#testimonials" className="block px-3 py-2 text-base font-medium text-white hover:bg-[#79894A]" onClick={() => setIsMenuOpen(false)} data-id="element-256" data-mp="mfpqq1gx5ggv">
              Testimonials
            </a>
            <a href="#about" className="block px-3 py-2 text-base font-medium text-white hover:bg-[#79894A]" onClick={() => setIsMenuOpen(false)} data-id="element-257" data-mp="rdrciu5qbtw1">
              About
            </a>
            <a href="#faq" className="block px-3 py-2 text-base font-medium text-white hover:bg-[#79894A]" onClick={() => setIsMenuOpen(false)} data-id="element-258" data-mp="1051d35f64qa8">
              FAQ
            </a>
            <a href="/contact" className="block px-3 py-2 text-base font-medium bg-[#3A4A46] text-white rounded" onClick={() => setIsMenuOpen(false)} data-id="element-259" data-mp="1a50kgyzuqali">
              Book a Call
            </a>
          </div>
        </div>}
    </header>;
}